import { MatchResultModel } from './../models/MatchResultModel';
import { ActionTree } from 'vuex';
import { LeagueState, Settings, LeagueTableViewItem, NextMatchWidgetModel, LastMatchWidgetModel } from './models';
import { RootState } from '@/store';
import api from './api';
import { Mutations } from './mutations';
import Notify from '@/shared/services/Notify/Notify';
import { ErrorApi } from '@/core/api/ErrorApi';

export enum Actions {
  FETCH_LEAGUE_SETTINGS = 'FETCH_LEAGUE_SETTINGS',
  FETCH_LEAGUE_TABLE = 'FETCH_LEAGUE_TABLE',
  FETCH_NEXT_MATCH_WIDGET = 'FETCH_NEXT_MATCH_WIDGET',
  FETCH_LAST_MATCH_WIDGET = 'FETCH_LAST_MATCH_WIDGET',
  FETCH_LAST_MATCH_DAY_RESULTS_WIDGET = 'FETCH_LAST_MATCH_DAY_RESULTS_WIDGET',
}

export const actions: ActionTree<LeagueState, RootState> = {

  async [Actions.FETCH_LEAGUE_SETTINGS]({ commit }) {
    commit(Mutations.GET_LEAGUE_SETTINGS_REQUEST);
    await api.fetchLeagueSettings().then(
      (payload: Settings) => {
        commit(Mutations.GET_LEAGUE_SETTINGS_SUCCESS, payload);
      },
      (error: ErrorApi) => {
        commit(Mutations.GET_LEAGUE_SETTINGS_FAILURE);
        Notify.errorApi(error);
      },
    );
  },

  async [Actions.FETCH_LEAGUE_TABLE]({ commit }, seasonId?: number) {
    commit(Mutations.GET_LEAGUE_TABLE_REQUEST);
    await api.fetchLeagueTable(seasonId).then(
      (payload: LeagueTableViewItem[]) => {
        commit(Mutations.GET_LEAGUE_TABLE_SUCCESS, payload);
      },
      (error: ErrorApi) => {
        commit(Mutations.GET_LEAGUE_TABLE_FAILURE);
        Notify.errorApi(error);
      },
    );
  },

  async [Actions.FETCH_NEXT_MATCH_WIDGET]({ commit }, fetchNextMatch: any): Promise<void> {
    commit(Mutations.GET_NEXT_MATCH_WIDGET_REQUEST);
    await api.fetchNextMatchWidget(fetchNextMatch.seasonId, fetchNextMatch.teamId).then(
      (payload: NextMatchWidgetModel) => {
        commit(Mutations.GET_NEXT_MATCH_WIDGET_SUCCESS, payload);
      },
      (error: ErrorApi) => {
        commit(Mutations.GET_NEXT_MATCH_WIDGET_FAILURE);
        Notify.errorApi(error);
      },
    );
  },

  async [Actions.FETCH_LAST_MATCH_WIDGET]({ commit }, fetchLastMatch: any): Promise<void> {
    commit(Mutations.GET_LAST_MATCH_WIDGET_REQUEST);
    await api.fetchLastMatchWidget(fetchLastMatch.seasonId, fetchLastMatch.teamId).then(
      (payload: LastMatchWidgetModel) => {
        commit(Mutations.GET_LAST_MATCH_WIDGET_SUCCESS, payload);
      },
      (error: ErrorApi) => {
        commit(Mutations.GET_LAST_MATCH_WIDGET_FAILURE);
        Notify.errorApi(error);
      },
    );
  },

  async [Actions.FETCH_LAST_MATCH_DAY_RESULTS_WIDGET]({ commit }, fetchLastMatchDayResults: any): Promise<void> {
    commit(Mutations.GET_LAST_MATCH_DAY_RESULTS_WIDGET_REQUEST);
    await api.fetchLastMatchDayResultsWidget(fetchLastMatchDayResults.seasonId).then(
      (payload: MatchResultModel[]) => {
        commit(Mutations.GET_LAST_MATCH_DAY_RESULTS_WIDGET_SUCCESS, payload);
      },
      (error: ErrorApi) => {
        commit(Mutations.GET_LAST_MATCH_DAY_RESULTS_WIDGET_FAILURE);
        Notify.errorApi(error);
      },
    );
  },

};
